
export const routes = (prefix) => [
    {
        path: `/${prefix}/hospitaldocuments`,
        name: `${prefix}.hospitaldocuments.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.hospitaldocuments.index`,
                PageDescription: "Hosptial Documents Listing/Create",
            }
        }
    },
];
